import { cdnOrigin } from '@maxpreps/network/src/origins';
import React from 'react';
import styled from 'styled-components';
import { AdType } from '../../../constants/ads';
import { COLOR } from '../../../styles/colors';
import AdUnit from '../../AdUnit/AdUnit';
import LinkSet from './LinkSet/LinkSet';
import Logo from './Logo/Logo';
import SocialLinks from './SocialLinks/SocialLinks';

const StyledGlobalFooter = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: ${COLOR.white};
  position: relative;
  padding: 72px 50px 50px 50px;
  height: calc(100vh - 100px);
  max-height: 540px;
  min-height: 400px;
  box-sizing: border-box;
  background: ${props => props.theme.colors.nav.footer};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: column nowrap;
`;

const CBSLogo = styled.img`
  display: inline-block;
  width: 150px;
  height: 18px;
`;

const Legalese = styled.div`
  font-size: 12px;
  text-align: center;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
`;

const Copyright = styled.div`
  font-size: 12px;
  color: ${COLOR.white};

  line-height: 1.5;
`;

const Trademark = styled.div`
  margin: 8px 0 0;
  opacity: 0.6;
`;

/* Out of page ad lives here (and not next to the skybox) because it was inserting
Some weird spacing and i didn't want it to shift the page around when it did that
*/
const GlobalFooter = () => (
  <>
    <StyledGlobalFooter>
      <Logo />
      <SocialLinks />
      <LinkSet />

      <CBSLogo
        src={`${cdnOrigin}/includes/images/footer/c-b-s-sports-digital.png`}
        alt="A CBS Sports Digital Property"
        loading="lazy"
      />
      <Legalese>
        <Copyright>
          © 2005-{new Date().getFullYear()} CBS Interactive Inc. All rights
          reserved.
        </Copyright>
        <Trademark>
          MaxPreps is a registered trademark of CBS Broadcasting Inc.
        </Trademark>
      </Legalese>
    </StyledGlobalFooter>
    <AdUnit isOutOfPage code={AdType.OutOfPage} />
  </>
);

export default GlobalFooter;
